import { gql, useMutation } from '@apollo/client';
import {
  FetchCampaignsByPlacementIdQuery,
  VALID_CAMPAIGN_STATES,
} from 'modules/campaigns/editor/hooks';
import { queryCampaignById } from 'modules/campaigns/editor/queries';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { TOAST_ACTIONS } from '../constants';

export const UpdateDisplayPriorityMutation = gql`
  mutation UpdateDisplayPriorities($priorities: [CampaignDisplayPriorityUpdate!]!) {
    updateCampaignDisplayPriorities(priorities: $priorities) {
      success
      failure {
        message
      }
    }
  }
`;

export const useUpdateDisplayPriorities = (placementId?: number, campaignId?: number) => {
  const dispatch = useDispatch();

  const [updateDisplayPriorities, { loading, error }] = useMutation(UpdateDisplayPriorityMutation, {
    refetchQueries: [
      {
        query: FetchCampaignsByPlacementIdQuery,
        variables: { placementId, campaignStates: VALID_CAMPAIGN_STATES },
      },
      { query: queryCampaignById, variables: { id: campaignId } },
    ],
    onCompleted: (data) => {
      if (data?.updateCampaignDisplayPriorities?.failure?.message)
        dispatch(
          addNegativeToastWithErrorId(
            'Could not update display priorities, please try again.',
            TOAST_ACTIONS.updateDisplayPriorities,
            new Error(data.updateCampaignDisplayPriorities.failure.message),
          ),
        );
    },
    onError: (e) => {
      dispatch(
        addNegativeToastWithErrorId(
          'Could not update display priorities, please try again.',
          TOAST_ACTIONS.updateDisplayPriorities,
          e,
        ),
      );
    },
  });

  return {
    updateDisplayPriorities,
    loading,
    error,
  };
};
